import React from "react";
import "./Traiteur.css";

const occasions = ["Mariage", "Anniversaire", "Événement privé", "Chef à domicile"];

const plats = [
  { src: "/images/Traiteur/traiteur-plat-1.jpg", alt: "Bouchées apéritives dressées sur plateau" },
  { src: "/images/Traiteur/traiteur-plat-4.jpg", alt: "Poulpe mariné, ciboulette" },
  { src: "/images/Traiteur/traiteur-plat-5.jpg", alt: "Carpaccio de bœuf maturé, roquette et parmesan" },
  { src: "/images/Traiteur/traiteur-plat-6.jpg", alt: "Tataki de thon rouge, quinoa soufflé" },
  { src: "/images/Traiteur/traiteur-plat-2.jpg", alt: "Croquettes façon Trilogie, sauce maison" },
  { src: "/images/Traiteur/traiteur-plat-3.jpg", alt: "Ailes de poulet croustillantes, ciboulette" },
  { src: "/images/Traiteur/traiteur-plat-7.jpg", alt: "Trio de mises en bouche" },
  { src: "/images/Traiteur/traiteur-plat-8.jpg", alt: "Service de bouchées passées en salle" },
];

const showcase = [
  { src: "/images/Traiteur/traiteur-event-1.jpg", alt: "Bar à cocktails installé pour un événement privé", label: "Bar sur mesure" },
  { src: "/images/Traiteur/traiteur-event-4.jpg", alt: "Arche décorative à l'entrée d'une réception", label: "Une arrivée mise en scène" },
  { src: "/images/Traiteur/traiteur-event-2.jpg", alt: "Escalier illuminé de bougies", label: "Une ambiance feutrée" },
  { src: "/images/Traiteur/traiteur-event-3.jpg", alt: "Hall d'entrée d'une réception privée", label: "Un lieu transformé" },
];

function Traiteur() {
  return (
    <main className="traiteur-page" aria-labelledby="traiteur-title">

      {/* ── En-tête ─────────────────────────────────────────── */}
      <header className="traiteur-header">
        <span className="traiteur-eyebrow">Trilogie hors les murs</span>
        <h1 id="traiteur-title">
          Notre service <em>traiteur</em>
        </h1>
        <div className="traiteur-header-divider" />
        <p className="lead">
          Trilogie se déplace également pour vos événements. Nous vous faisons
          vivre notre expérience gastronomique, avec la même attention et le
          même savoir-faire qu'au restaurant.
        </p>
        <ul className="traiteur-occasions" aria-label="Types d'événements">
          {occasions.map((o) => (
            <li key={o} className="traiteur-occasion-tag">{o}</li>
          ))}
        </ul>
      </header>

      {/* ── Galerie plats ───────────────────────────────────── */}
      <section className="traiteur-gallery-section" aria-labelledby="traiteur-gallery-title">
        <div className="traiteur-section-intro">
          <span className="traiteur-section-number">01</span>
          <h2 id="traiteur-gallery-title">Nos créations, en format bouchée</h2>
        </div>
        <div className="traiteur-gallery-grid">
          {plats.map((p, i) => (
            <figure className="traiteur-gallery-item" key={i}>
              <img src={p.src} alt={p.alt} loading="lazy" />
            </figure>
          ))}
        </div>
      </section>

      {/* ── Showcase événement ──────────────────────────────── */}
      <section className="traiteur-showcase-section" aria-labelledby="traiteur-showcase-title">
        <div className="traiteur-section-intro">
          <span className="traiteur-section-number">02</span>
          <h2 id="traiteur-showcase-title">Une réception, un lieu transformé</h2>
          <p className="traiteur-section-text">
            De la décoration à l'assiette, en passant par le service et le bar,
            nous prenons en charge chaque détail pour que votre événement vous
            ressemble.
          </p>
        </div>
        <div className="traiteur-showcase-grid">
          {showcase.map((s, i) => (
            <figure className="traiteur-showcase-item" key={i}>
              <img src={s.src} alt={s.alt} loading="lazy" />
              <figcaption>{s.label}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* ── CTA ─────────────────────────────────────────────── */}
      <footer className="traiteur-footer">
        <p className="traiteur-footer-text">
          Faites-nous part de vos envies, nous nous occupons du reste.
        </p>
        <a
          className="contact-btn"
          href="mailto:trilogie.restaurant@gmail.com?subject=Demande%20traiteur"
        >
          Demander un devis
          <span className="contact-btn-arrow" />
        </a>
      </footer>

    </main>
  );
}

export default Traiteur;
